module.exports = __webpack_public_path__ + "static/img/estacio-logo.26398ed.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/img/estacio-logo.jpg
// module id = 226
// module chunks = 6